module.exports = __webpack_public_path__ + "img/0Q3A6289_L_Black_MockedUp.971e5405.jpg";